import { getGenderValue } from "@utils/helpers";

import { ApiOrganizationUserRolesRoleChoices, ProviderRoleEnums, ProviderType } from "@api/graphql/types-and-hooks";
import { MemberProvider, ProviderRole } from "@pages/Members/types";
import { getRoleLabelFromEnum } from "@pages/Members/utils/providerRoles";

export const mapProviderToMemberProvider = (provider: ProviderType | null | undefined): MemberProvider | null => {
  if (!provider || !provider.providermetadata) return null;
  const { firstName, lastName, email, invitationStatus, invitationCreatedAt, invitationUrl, gender, specifyGender } =
    provider.providermetadata;

  const rawRoles = provider.organizationuserrolesSet.edges.map((edge) => edge?.node?.role).filter(Boolean);
  const roles = rawRoles.map((role) => getRoleLabelFromEnum(role as string)) as ProviderRole[];

  return {
    id: provider.id,
    firstName: firstName || "",
    lastName: lastName || "",
    name: `${firstName || ""} ${lastName || ""}`.trim(),
    email: email || "",
    roles,
    roleEnums: rawRoles as unknown as ProviderRoleEnums[],
    assignedClientsCount: provider.learnerproviderSet.edges.filter((edge) => edge?.node?.learner?.archived !== true)
      .length,
    portalStatus: invitationStatus ?? null,
    invitedDate: invitationCreatedAt || undefined,
    invitationUrl: invitationUrl || undefined,
    gender: getGenderValue(gender) || undefined,
    specifyGender: specifyGender || undefined,
    clients: [],
    isFronteraInternal: provider.organizationuserrolesSet.edges.some(
      (edge) => edge?.node?.role === ApiOrganizationUserRolesRoleChoices.FronteraInternal,
    ),
    hasInternalEmail: email?.toLowerCase().endsWith("@frontera.health") ?? false,
  };
};
